import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-sky-500/10 bg-navy-950">
      <div className="section-shell py-14 sm:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="sm:col-span-2 lg:col-span-1">
          <Logo compact />
          <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-xs">
            Get Found. Get Enquiries. Automate Growth.
          </p>
          <p className="mt-3 text-sm text-slate-500 leading-relaxed max-w-xs">
            Websites, local visibility and smart automation for UK local businesses.
          </p>
          <a
            href="mailto:hello@sourceworldautomations.co.uk"
            data-testid="footer-link-email"
            className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-sky-400 hover:text-sky-300 transition-colors"
          >
            <Mail size={15} strokeWidth={2} /> hello@sourceworldautomations.co.uk
          </a>
        </div>
        <nav aria-label="Footer explore">
          <p className="micro-label mb-5">Explore</p>
          <ul className="space-y-3 text-sm">
            <li><a data-testid="footer-link-services" href="/#services" className="text-slate-400 hover:text-sky-400 transition-colors">Services</a></li>
            <li><a data-testid="footer-link-how-it-works" href="/#how-it-works" className="text-slate-400 hover:text-sky-400 transition-colors">How It Works</a></li>
            <li><a data-testid="footer-link-about" href="/#about" className="text-slate-400 hover:text-sky-400 transition-colors">About</a></li>
            <li><a data-testid="footer-link-contact" href="/#contact" className="text-slate-400 hover:text-sky-400 transition-colors">Contact</a></li>
          </ul>
        </nav>
        <nav aria-label="Footer case studies">
          <p className="micro-label mb-5">Case Studies</p>
          <ul className="space-y-3 text-sm">
            <li>
              <Link data-testid="footer-link-case-study" to="/case-study/one-time-auto-electrical" className="text-slate-400 hover:text-sky-400 transition-colors">
                One Time Auto Electrical Repairs
              </Link>
            </li>
            <li><a data-testid="footer-link-pricing" href="/#pricing" className="text-slate-400 hover:text-sky-400 transition-colors">Packages & Pricing</a></li>
            <li><a data-testid="footer-link-support" href="/#support" className="text-slate-400 hover:text-sky-400 transition-colors">Monthly Support</a></li>
          </ul>
        </nav>
        <nav aria-label="Footer legal">
          <p className="micro-label mb-5">Legal</p>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-link-privacy" to="/privacy-policy" className="text-slate-400 hover:text-sky-400 transition-colors">Privacy Policy</Link></li>
            <li><Link data-testid="footer-link-terms" to="/terms" className="text-slate-400 hover:text-sky-400 transition-colors">Terms of Service</Link></li>
          </ul>
        </nav>
      </div>
      <div className="border-t border-sky-500/10">
        <div className="section-shell py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {year} SourceWorld Automations. All rights reserved.</p>
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-slate-600">Built for UK local businesses</p>
        </div>
      </div>
    </footer>
  );
}
